<template>
  <div class="footer" style="display: flex; flex-direction: column; padding: 0;">
    <div class="sub">
			<h1>{{ $t('footer.title')}}</h1>
			<div class="content">
				<input class="sub-input" maxlength="20" :placeholder="$t('footer.placeholder')" v-model="email" />
				<button @click="sub()">{{$t('footer.submit')}}</button>
			</div>
			
		</div>
    <div class="container" style="flex-direction: unset;">
      <div class="copyright">© 2025 Copyright scoretv.cc</div>
      <div class="footer-lang">
        <div 
          class="lang" 
          :class="{ 'unset': applicationLocale !== item.code }" 
          v-for="(item, index) in locales"
          :key="index" 
          @click="onLocaleChange(item)"
        >
          <img src="/static/images/lang_cn.png" class="image" v-if="item.code === 'zh-Hans'" />
          <img src="/static/images/lang_en.png" class="image" v-else />
          {{ item.text }}
        </div>
      </div>
    </div>
    <div class="chat" @click="chat()">
      <img src="/static/images/chat.png"/>
    </div>
    <div class="chat-info" v-if="chat_open">
      <div class="title">
        <span>{{ $t('chat.title') }}</span>
        <i class="el-icon-more" style="font-size: 30px; cursor: pointer;" @click="chat()"></i>
      </div>
      <div class="chat-content">
        <div><img src="/static/images/chat-customer.png" class="chat-customer" /></div>
        <div class="chat-bubble">{{ $t('chat.bubble') }}</div>
      </div>
      <button class="button" @click="go()">{{ $t('chat.button') }}</button>
    </div>
  </div>
</template>

<script>
import i18nUtil from '@/utils/i18n'
import api from "@/api";
import { Message, MessageBox } from 'element-ui'
export default {
  name: 'Footer',
  props: {
    applicationLocale: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lang: 'cn',
      systemLocale: '',
      chat_open: false,
      email:''
    }
  },
  computed: {
    locales() {
      return [
        {
          text: this.$t('locale.zh-hans'),
          code: 'zh-Hans'
        },
        {
          text: this.$t('locale.en'),
          code: 'en'
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    handleImageError(item) {
      // 处理图片显示错误
    },
    onLocaleChange(e) {
      i18nUtil.setLocale(e.code)
      this.$i18n.locale = e.code
      this.$emit('changeLang', e.code)
    },
    chat() {
      this.chat_open = this.chat_open ? false : true
    },
    go() {
      window.location.href = 'https://t.me/letoultaff'
    },
    validateEmail(email) {
			  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
			  return re.test(String(email).toLowerCase())
			},
			sub(){
				if (!this.validateEmail(this.email)) {
          Message.error(this.$t('footer.placeholder'))
					return
				}
				api.postData('index/sub',{email:this.email})
					.then((res) => {
						if(res.data.message === '200'){
              Message.success(this.$t('footer.succes'))
							this.email = ''
						}else if(res.data.message === '400'){
							Message.success(this.$t('footer.succes'))
							this.email = ''
						}{
							
						}
					})
					.catch((error) => {
						console.log(error);
					});
			}
  }
}
</script>

<style>
@import '../../public/static/css/index.css';
  .sub{
      background: #000;
      width: 100%;
      align-items: center;
      justify-content: center;
      padding: 50px;
      gap: 10px;
      display: flex;
      flex-direction: column;
	}
	.sub .content .sub-input{
		background: #fff;
		border-radius: 5px;
		padding: 0 10px;
		color: #000;
		width: 300px;
		height: 50px;
		line-height: 50px;
	}
	.sub .content{
		gap: 10px;
		width: 100%;
		justify-content: center;
    display: flex;
	}
	.sub button{
		margin: 0;
		height: 50px;
		line-height: 50px;
		padding: 0 20px;
		background: #f90;
	}
</style>
